import DeletePopup from './DeletePopup';

export default DeletePopup;
